<template>
  <div class="l_basic_setting_faq">
    <div class="container">
      <div class="content">
        <h3>アプリのご利用にあたって</h3>
        <hr />
        <p>
          各種設定を有効にする事で、香の川製麺にご来店いただくと、来店スタンプをゲットすることができます。(スタンプは1日1回ゲットできます。1日1回の上限は24:00でリセットされます。)
        </p>
        <p v-if="canSIWA" class="caption">
          ※iOS13以下は「位置情報」「Bluetooth」 「通知」のみ表示されます。
        </p>
        <p v-else class="caption">
          ※Androidは「位置情報」「Bluetooth」 「通知」のみ表示されます。
        </p>
        <div class="l_button__external">
          <UIButton :label="'いますぐアプリ設定する'" @click="tapLink" />
        </div>
      </div>
      <div class="content">
        <h3>位置情報の設定について</h3>
        <hr />
        <p>
          位置情報を利用して、お得情報が付近で手に入ることをお知らせするために「常に許可」を選んでください。この機能はあとからでもOFFにできます。
        </p>
        <p style="margin-top: 1em">
          <span style="font-weight: bold">■iOS14以上の方</span><br />
          設定画面で位置情報を「常に許可」の上、「正確な位置情報」をONにしてください。
        </p>
        <div style="text-align: center">
          <img
            :src="require('@/assets/img/faq/location-setting-iphone.png')"
            style="width: 75%"
          />
        </div>
        <p v-if="!canSIWA">
          <span style="font-weight: bold">■Androidの方</span><br />
          設定画面で位置情報を「常に許可」の上、「位置情報精度オン」または「高精度」を選択してください。
        </p>
        <div v-if="!canSIWA" style="text-align: center">
          <img
            :src="require('@/assets/img/faq/location-setting-android.png')"
            style="width: 75%"
          />
        </div>
        <div class="l_button__external">
          <UIButton :label="'いますぐアプリ設定する'" @click="tapLink" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import { FactoryTrack } from '../constant/firebase.js'
import { mapActions } from 'vuex'
import '@/styles/color.css'

export default {
  name: 'FAQBasicSetting',
  components: {
    UIButton
  },
  async created() {
    document.title = '基本設定'

    await this.actionCanSIWA()
    try {
      window.receivedCanSIWA = (payload) => {
        console.log('receivedCanSIWA: ', payload)
        this.canSIWA = payload === 'true'
      }
    } catch (e) {
      console.log(e)
    }
  },
  data: function () {
    return {
      canSIWA: false
    }
  },
  methods: {
    ...mapActions('Native', ['actionNavigateTo', 'actionCanSIWA']),
    ...mapActions('Analytics', ['trackEvent']),
    goBack: function () {
      this.$router.push({ name: 'FAQ' })
    },
    tapLink() {
      this.trackEvent(FactoryTrack.createSettingApp())
      this.actionNavigateTo('1') // 1:許諾画面
    }
  }
}
</script>

<style lang="scss" scoped>
.l_basic_setting_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}

.l_basic_setting_faq h3,
.l_basic_setting_faq h4 {
  color: var(--accent-color);
}

.l_basic_setting_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;

}
.l_basic_setting_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}
.l_basic_setting_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid var(--accent-color);
}
.l_basic_setting_faq .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}

.caption {
  text-align: left;
  width: 100%;

  &.right {
    text-align: right;
  }

  font-size: 3vw;
  color: rgb(102, 102, 102);
}
</style>
